/**
 * Floyd storefront URL and language routing.
 * The behavior is preserved from the retired compatibility bundle.
 */

/*
* SEO and UX handling for product-page URLs and language variants:
* Corrects the shop URL.
* Redirects bots to a canonically matching alternate URL.
* Updates the browser URL without a reload for human visitors.
*/
(() => {
    let path = (new URL(window.location)).pathname;
    path = path.replace(/\/+$/, '');
    const origPath = path;
    let prefix = '';
    // Detect the /de language prefix and remove it from the path for subsequent checks.
    if (path.substring(0, 3) === '/de') {
        prefix = '/de';
        path = path.substring(3);
    }

    // Redirect /shop, with or without a trailing slash, to /collections/all while preserving the language prefix.
    if (path.match(/^\/shop\/?$/)) {
        window.location.href = prefix + '/collections/all';
        return;
    }

    // Detect bots from known user-agent tokens such as Googlebot, Bingbot and Lighthouse.
    const isBot = (() => {
        const agent = window.navigator.userAgent;
        const botUserAgentsArray = [
            'googlebot',
            'bingbot',
            'linkedinbot',
            'mediapartners-google',
            'lighthouse',
            'insights',
        ];
        for (let j = 0; j < botUserAgentsArray.length; j++) {
            if (agent.toLowerCase().indexOf(botUserAgentsArray[j].toLowerCase()) !== -1) {
                return true;
            }
        }
        return false;
    })();

    document.addEventListener('DOMContentLoaded', () => {
        const alternateHrefs = [];

        /*
        * Collect hreflang alternates without a type attribute and store their paths.
        *
        */
        document.head.querySelectorAll('link[rel="alternate"]').forEach((linkEl) => {
            let href = linkEl.getAttribute('href');
            if (linkEl.getAttribute('type') || !linkEl.getAttribute('hreflang') || !href) {
                return;
            }
            alternateHrefs.push(href.substring(0, 4) === 'http' ? (new URL(href)).pathname : href);
        });

        /*
        * Check whether an alternate URL path starts with the original path, including an optional /de prefix.
        * If no matching alternate exists:
        * Choose the best-fit alternate:
        * Prefer /de when the visitor is on the /de variant; otherwise use the first alternate.
        * When found:
        * Bots: perform a hard redirect with window.location.href.
        * Human visitors: update browser history with replaceState without reloading.
        *
        * */
        if (path.match(/\/products\//)) {
            const haveMatchingHreflang = alternateHrefs.some((href) => href.substring(0, origPath.length) === origPath);
            if (!haveMatchingHreflang) {
                let bestFitHref = null;
                alternateHrefs.forEach((href) => {
                    if ((href.substring(0, 3) === '/de' && prefix === '/de') || !bestFitHref) {
                        bestFitHref = href;
                    }
                });
                if (bestFitHref) {
                    if (isBot) {
                        window.location.href = bestFitHref;
                    } else {
                        history.replaceState(history.state, '', bestFitHref);
                    }
                }
            }
        }
    });
})();
